import { render, staticRenderFns } from "./ContractorInfo.vue?vue&type=template&id=51fe2d8e&scoped=true&"
import script from "./ContractorInfo.vue?vue&type=script&lang=js&"
export * from "./ContractorInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContractorInfo.vue?vue&type=style&index=0&id=51fe2d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe2d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51fe2d8e')) {
      api.createRecord('51fe2d8e', component.options)
    } else {
      api.reload('51fe2d8e', component.options)
    }
    module.hot.accept("./ContractorInfo.vue?vue&type=template&id=51fe2d8e&scoped=true&", function () {
      api.rerender('51fe2d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/contractors/ContractorInfo.vue"
export default component.exports